import Avatar from './Avatar';
import './Avatar.css';

export default Avatar;



// WEBPACK FOOTER //
// ./src/shared/components/Avatar/index.js